import { api } from '@/api';

export interface ChatDocumentBulkGetDocumentRequest {
  documentIds: string[];
}

export interface ChatDocumentBulkGetDocumentResponse {
  documents: { fletchDocumentId: string; downloadPath: string; downloadToken: string }[];
}

const chatDocumentBulkGetDocumentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatDocumentBulkGetDocument: builder.query<
      ChatDocumentBulkGetDocumentResponse,
      ChatDocumentBulkGetDocumentRequest
    >({
      query: ({ documentIds }) => ({
        url: 'document/bulk-get-document',
        method: 'GET',
        params: { fletchDocumentIds: documentIds },
      }),
    }),
  }),
});

export const { useLazyGetChatDocumentBulkGetDocumentQuery } = chatDocumentBulkGetDocumentApi;
